import { PrefectureId } from './prefecture';

import { Result } from '@/packages/nurse-senka-frontend-sdk';

type IsAddressUpdateRequest = {
  postalCode?: string;
  prefectureId?: PrefectureId;
  locality?: string;
  streetAddress?: string;
  building?: string;
};
export const isAddressUpdate = (request: IsAddressUpdateRequest): boolean => {
  if (
    request.postalCode ||
    request.prefectureId ||
    request.locality ||
    request.streetAddress
  ) {
    return true;
  }

  return false;
};

type FetchAddressResponse = {
  postalCode: string;
  prefectureId: PrefectureId;
  locality: string;
};
export type FetchAddressByPostalCode = (
  postalCode: string,
) => Promise<Result<FetchAddressResponse, Error>>;
